/* <product-recommendations data-url> — görünür olunca section'ı öneri bağlamında çeker (complementary / related).
   <product-combo> — "Birlikte sık tercih edilenler": seçili kartların toplamı ve tek istekte sepete ekleme. */
if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.loaded || !this.dataset.url) return;
      if (!('IntersectionObserver' in window)) return this.load();
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    async load() {
      this.loaded = true;
      try {
        const html = await fetch(this.dataset.url).then((r) => r.text());
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('product-recommendations');
        if (fresh && fresh.innerHTML.trim()) {
          this.innerHTML = fresh.innerHTML;
          this.classList.add('is-loaded');
        }
      } catch (e) {
        /* öneri yoksa section boş kalır */
      }
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);
}

if (!customElements.get('product-combo')) {
  class ProductCombo extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.button = this.querySelector('[data-combo-submit]');
      this.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', (e) => this.submit(e));
      this.update();
    }

    get selected() {
      return Array.from(this.querySelectorAll('input[name="id[]"]:checked'));
    }

    update() {
      const list = this.selected;
      const total = list.reduce((sum, el) => sum + Number(el.dataset.price || 0), 0);
      const count = this.querySelector('[data-combo-count]');
      if (count) count.textContent = (count.dataset.template || '').replace('__N__', list.length);
      const totalEl = this.querySelector('[data-combo-total]');
      if (totalEl) totalEl.textContent = CPL.formatMoney(total);
      if (this.button) this.button.disabled = list.length === 0;
    }

    async submit(e) {
      e.preventDefault();
      const items = this.selected.map((el) => ({ id: Number(el.value), quantity: 1 }));
      if (!items.length || this.button.classList.contains('is-loading')) return;
      this.button.classList.add('is-loading');
      this.button.setAttribute('aria-busy', 'true');
      try {
        await CPL.cart.add(items, 'combo');
        const type = (window.cplSettings && window.cplSettings.cartType) || 'drawer';
        const drawer = document.querySelector('cart-drawer');
        if (type === 'page' || !drawer) window.location.href = window.routes.cart_url;
        else if (type === 'notification') CPL.toast({ type: 'cart', text: window.cplStrings?.addedToCart || '' });
        else drawer.open(this.button);
      } catch (err) {
        CPL.toast({ type: 'error', text: (err && (err.description || err.message)) || window.cplStrings?.cartError || '' });
      } finally {
        this.button.classList.remove('is-loading');
        this.button.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('product-combo', ProductCombo);
}
